import Module from '../utils/Module';
import EventsManager from '../utils/EventsManager';
import CustomEvents from '../utils/CustomEvents';
import ResizeManager from '../utils/ResizeManager';
import gsap from 'gsap/gsap-core';

export default class HeaderModule extends Module {
  constructor(options) {
    super(options)

    this.DOMEl = this.options.element;
    this.headerLogo = this.DOMEl.querySelector(".header__logo a");
    this.innerMenu = this.DOMEl.querySelector(".header__nav");

    this.dropdownLinks = this.DOMEl.querySelectorAll(".menu-item--expanded");
    this.menuLinks = this.DOMEl.querySelectorAll(".menu--main a");

    this.languageLinks = this.DOMEl.querySelectorAll('.language-link');

    this.burgerBtn = this.DOMEl.querySelector(".burger-menu-btn");
    this.mobilePopupMenu = this.DOMEl.querySelector(".nav__popup-mobile");

    this.mobileMenuLinks = this.mobilePopupMenu.querySelectorAll("li");

    this.linksTimeline = gsap.timeline().pause();

    this.savedScrolledPos = 0;

    this.buttonLogin = document.querySelectorAll('#edit-submit');


    this.init();

    //ResizeManager.bind('menu-resize', this.onResize.bind(this));
  }

  init() {
    this.headerLogo.addEventListener('click', this.trackLogoClick);


    this.dropdownLinks.forEach(dropdownLink => {
      dropdownLink.addEventListener('mouseenter', this.onOpenDropdown.bind(this));
      dropdownLink.addEventListener('mouseleave', this.onCloseDropdown.bind(this));

      dropdownLink.addEventListener('click', this.onOpenDropdownMobile.bind(this));

      //dropdownLink.querySelector(".menu li:last-child a").addEventListener('blur', this.onCloseDropdown.bind(this));
    });

    this.menuLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        this.trackMenuClick(link);
      });
    });

            this.languageLinks.forEach(link => {
              link.addEventListener('click', (event) => {
                event.stopPropagation();
                this.trackLanguageLinkClick(link);
              });
            });

            document.addEventListener('scroll', this.onScroll.bind(this));

            this.burgerBtn.addEventListener("click", this.toggleMenuBurger.bind(this));

    this.linksTimeline.fromTo(
      this.mobileMenuLinks,
      {css: {'opacity': 0, 'transform': 'translate3d(0, 15px, 0)'}},
      {css: {'opacity': 1, 'transform': 'translate3d(0, 0, 0)'}, duration: 0.3, delay: 0.2, stagger: 0.1}
    );

    if (this.buttonLogin.length > 0) {
      this.buttonLogin.forEach(button => {
        button.innerHTML = "<span>" + button.innerText + "</span>"
      });
    }
    //this.onLoad();
  }

  // onLoad () {
  //   EventsManager.broadcast(CustomEvents.commons.moduleLoaded, 'HeaderModule')
  // }

  // hide or display menu on scroll
  onScroll(e) {
    let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;

    let scrollDirection = '';

    if (currentScroll > 0 && this.savedScrolledPos <= currentScroll) {
      this.savedScrolledPos = currentScroll;
      scrollDirection = 'down';
    } else {
      this.savedScrolledPos = currentScroll;
      scrollDirection = 'up';
    }

    if (currentScroll < 100) {


      this.innerMenu.classList.remove("header__nav--hide")
      this.innerMenu.classList.remove("header__nav--minified")
    } else {
      if (currentScroll > 100 && scrollDirection === "down") {
        this.innerMenu.classList.add("header__nav--hide")
        this.innerMenu.classList.remove("header__nav--minified");
      } else if (currentScroll > 100 && scrollDirection === "up") {
        this.innerMenu.classList.remove("header__nav--hide")
        this.innerMenu.classList.add("header__nav--minified")
      }
    }

    this.savedScrolledPos = currentScroll;
  }

  //for mobile menu
  toggleMenuBurger() {

    if (!this.burgerBtn.classList.contains("active")) {
      this.burgerBtn.classList.add("active");
      this.mobilePopupMenu.style.display = "block";
      document.body.classList.add("block-scroll");

      this.innerMenu.classList.add("header__nav--expanded-mobile")

      this.linksTimeline.restart();
    } else {
      this.burgerBtn.classList.remove("active")
      this.mobilePopupMenu.style.display = "none";
      document.body.classList.remove("block-scroll");
      this.innerMenu.classList.remove("header__nav--expanded-mobile");
    }
  }

  // for mobile submenu
  onOpenDropdownMobile(e) {
    document.querySelector(".header-container").classList.add("header-container--expanded");
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if( viewportWidth < 1200)
    {
      if(e.target.parentElement.classList.contains('active'))
      {
        e.target.parentElement.classList.remove("active");
        e.target.parentElement.querySelector(".menu").style.visibility = "hidden";
        e.target.parentElement.querySelector(".menu").style.maxHeight = 0;
        setTimeout(() => {
          e.target.parentElement.querySelector(".menu").classList.remove("active");
        }, 200)
      }
      else
      {
        e.target.parentElement.classList.add("active");
        e.target.parentElement.querySelector(".menu").style.visibility = "visible";
        e.target.parentElement.querySelector(".menu").style.maxHeight = '500px';
        setTimeout(() => {
          e.target.parentElement.querySelector(".menu").classList.add("active");
        }, 200)
      }
    }
  }

  // for desktop menu
  onOpenDropdown(e) {
    document.querySelector(".header-container").classList.add("header-container--expanded");
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if( viewportWidth > 1200)
    {
      e.target.classList.add("active");
      e.target.querySelector(".menu").style.display = "block";
      setTimeout(() => {
        e.target.querySelector(".menu").classList.add("active");
      }, 200)
    }
  }

  onCloseDropdown(e) {
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if( viewportWidth > 1200)
    {
      const menuItems = document.querySelector(".header-container--expanded .menu-item--expanded");

      if (menuItems) {
        menuItems.classList.remove("active");
        menuItems.querySelector(".menu").style.display = "none";
      }

      document.querySelector(".header-container").classList.remove("header-container--expanded");

      if (this.DOMEl.querySelector(".menu.active")) {
        this.DOMEl.querySelector(".menu.active").classList.remove("active");
      }
    }
  }

  onResize() {
    if (this.burgerBtn.classList.contains("active")) {
      this.burgerBtn.classList.remove("active")
      this.mobilePopupMenu.style.display = "none";
      document.body.classList.remove("block-scroll");
      this.innerMenu.classList.remove("header__nav--expanded-mobile");
    }
  }

  trackLogoClick() {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "header interaction",
        "action": "click on logo"
      }
    });
  }


  trackMenuClick(link) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "header interaction",
        "action": "click on top navigation",
        "label": link.text
      }
    });
  }

  trackLanguageLinkClick(link) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "header interaction",
        "action": "language change",
        "label": link.getAttribute('hreflang')
      }
    });
  }
}
